module.exports = __webpack_public_path__ + "static/media/1846120.356436be.geojson";


//////////////////
// WEBPACK FOOTER
// ./src/elections/us/GeoData/1846120.geojson
// module id = 338
// module chunks = 0